module.exports = __webpack_public_path__ + "static/anna-kendrick-8b80688dbb5c07d504120339247cfd29.jpg";